import React from "react";
import { labelUtils } from "../Util";
import FormGroupWrapper from "./FormGroupWrapper";
import store from "../../../../store";
import { setRendererFormState } from "../../../../store/slices/commonSlice";

const Password = ({
  arrEle,
  newElfromJSON,
  fieldEle,
  formState,
  displayLabelKey,
  databaseKey,
}) => {
  let key = databaseKey ? databaseKey : displayLabelKey;

  return (
    <FormGroupWrapper
      arrEle={arrEle}
      newElfromJSON={newElfromJSON}
      fieldEle={fieldEle}
    >
      <div
        className="form-builder-element"
        style={{ width: labelUtils.getElementWidth(fieldEle) }}
      >
        <input
          id={newElfromJSON}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
            }
          }}
          className="form-control"
          type="password"
          placeholder={fieldEle?.["display-placeholder"]}
          disabled={fieldEle?.["display-disabled"] === 1}
          required={fieldEle?.["display-required"] === 1}
          minLength={fieldEle?.["validation-minlength"]}
          maxLength={fieldEle?.["validation-maxlength"]}
          name={key}
          value={formState[key] || ""}
          onChange={(e) =>
            store.dispatch(
              setRendererFormState({ key, value: e.target.value })
            )
          }
        />
        <div className="invalid-feedback">This field is required</div>
        {fieldEle?.["display-description"] && (
          <div className="form-text text-muted formElementDesc">
            {fieldEle?.["display-description"]}
          </div>
        )}
      </div>
    </FormGroupWrapper>
  );
};

export default Password;
